'use strict';

class ScrollButton {
    constructor() {
        this.b24LastButtonShow = false;
        this.registerEventListeners();
    }

    createScrollButton() {
        let scrollButton = document.createElement('div');
        scrollButton.className = 'scroll-button scroll-button_hide';
        scrollButton.id = 'scroll-button';

        let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.classList.add('scroll-button__svg');

        let use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
        use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '/bitrix/templates/timecity/img/sprites/sprite.svg?1#up');

        svg.appendChild(use);
        scrollButton.appendChild(svg);
        document.body.appendChild(scrollButton);

        return scrollButton;
    }

    toggleButtonVisibility(show) {
        if (show) {
            this.scrollButton.classList.remove('scroll-button_hide');
            this.scrollButton.classList.add('scroll-button_show');
        } else {
            this.scrollButton.classList.remove('scroll-button_show');
            this.scrollButton.classList.add('scroll-button_hide');
        }
    }

    smoothScrollTo(targetElement, targetPosition, offset, duration) {
        if (!targetElement && !targetPosition) {
            targetPosition = 0;
        }

        let startTime = Date.now();
        let start = window.scrollY;

        const animateScroll = () => {
            if (targetElement) {
                targetPosition = targetElement.offsetTop - offset;
            }

            let currentTime = Date.now() - startTime;
            let progress = Math.min(currentTime / duration, 1);
            let current = start + (targetPosition - start) * progress;

            window.scrollTo(0, current);

            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            } else {
                window.scroll(0, targetPosition);
            }
        };

        animateScroll();
    }

    registerEventListeners() {
        document.addEventListener('DOMContentLoaded', () => {
            this.scrollButton = this.createScrollButton();

            let hash = window.location.hash;
            if (hash) {
                let anchor = document.getElementById(hash.slice(1));
                if (anchor) {
                    window.scroll(0, 0);
                    this.smoothScrollTo(anchor, undefined, 120, 750);
                }
            }

            setTimeout(() => {
                if (window.scrollY > 0) {
                    this.toggleButtonVisibility(true);
                }
            }, 0);

            this.scrollButton.addEventListener('click', () => {
                // Целевая позиция -1 а не 0 что бы сафари докручивал до самого верха,
                // иначе он может не докрутить +-10-40px
                this.smoothScrollTo(undefined, -1, 0, 500);
            });

            window.addEventListener('scroll', () => {
                let shouldShow = window.scrollY > 0 && !this.b24LastButtonShow
                this.toggleButtonVisibility(shouldShow);
            });
        });

        window.addEventListener('onBitrixLiveChat', event => {
            let button = event.detail.widget.buttonInstance.container.querySelector('.b24-widget-button-social');

            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.attributeName === 'class') {
                        let b24CurrentButtonShow = button.classList.contains('b24-widget-button-show');
                        if (b24CurrentButtonShow !== this.b24LastButtonShow) {
                            this.b24LastButtonShow = b24CurrentButtonShow;
                            this.toggleButtonVisibility(window.scrollY > 0 && !this.b24LastButtonShow);
                        }
                    }
                });
            });

            observer.observe(button, {
                attributes: true
            });
        });
    }
}

// Инициализация нового объекта ScrollButton
new ScrollButton();